import { apiCall, apiCallPublic, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import { newsDetailsMock, newsListHomeMock, newsListMock } from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { newsPath } from '../../utils/paths';

export default {
  newsListGet: ({ filters, isLogged, isPublic }) => {
    if (shouldUseMock()) {
      return newsListMock();
    }
    return isLogged && !isPublic
      ? apiCall(
          `${baseUrl}${newsPath}news/private/list${parseQueryParams(filters)}`,
          'GET'
        )
      : apiCallPublic(
          `${baseUrl}${newsPath}news/public/list${parseQueryParams(filters)}`,
          'GET'
        );
  },
  homeNewsListGet: ({ filters, isLogged, isPublic }) => {
    if (shouldUseMock()) {
      return newsListHomeMock();
    }
    return isLogged && !isPublic
      ? apiCall(
          `${baseUrl}${newsPath}highlight/news/private/list${parseQueryParams(
            filters
          )}`,
          'GET'
        )
      : apiCallPublic(
          `${baseUrl}${newsPath}highlight/news/public/list${parseQueryParams(
            filters
          )}`,
          'GET'
        );
  },
  newsDetailsGet: ({ id, isLogged, isPublic }) => {
    if (shouldUseMock()) {
      return newsDetailsMock();
    }
    return isLogged && !isPublic
      ? apiCall(`${baseUrl}${newsPath}news/private/${id}`, 'GET')
      : apiCallPublic(`${baseUrl}${newsPath}news/public/${id}`, 'GET');
  },
};
